import React from 'react';
import { Link } from 'react-router-dom';

const NoPageFound = () => {
  return (
    <div className="container d-flex align-items-center justify-content-center min-vh-100">
      <div className="row justify-content-center text-center">
        <div className="col-lg-8 col-md-10">
          <h1 className="display-1 fw-bold text-primary">404</h1>
          <h2 className="fw-semibold mb-3 text-dark">Oops! Page Not Found</h2>
          <p className="text-muted mb-4">
            The page you're looking for doesn't exist, or it might have been moved.
          </p>
          <Link to="/index" className="btn btn-lg btn-primary px-5">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NoPageFound;
